<template>
  <section class="f-56">
    <div class="content" v-bg bg-url="@/v2/auto/assets/image/56/0.jpg">
      <div class="title f-center-title">多脑并行，每个音区都有专属 AI 助理</div>
      <div class="f-center-sub-title">
        主驾、副驾、后排都可同时唤起 AI 小窗，探索自己的 AI 玩法
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      preload_: true,
    }
  },
}
</script>

<style lang="less" scoped>
.f-56 {
  width: 100%;
  background: #000000;
  overflow: hidden;

  .content {
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    aspect-ratio: 3840/2160;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    color: #ffffff;
  }

  .title {
    background: radial-gradient(
      131.96% 70.14% at 50% 18.06%,
      #eadaff 0%,
      #ffffff 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    font-weight: bold;
    margin-top: 6%;
    margin-bottom: 20px;
  }
}
</style>
